/**
 * SKAPIX Fullpage Slider — Frontend-Einstieg.
 *
 * Initialisiert Engines und Slider, stellt die globale API
 * window.SkapixFullpage bereit und feuert `sfps:init`.
 */

import { FullpageEngine } from './FullpageEngine.js';
import { HorizontalSlider } from './HorizontalSlider.js';
import { isEditMode } from './utils.js';

const globalConfig = window.SkapixFullpageConfig || { defaults: {}, i18n: {} };
const engines = [];
const readyQueue = [];
let initialized = false;

const api = {
	engines,

	/**
	 * Liefert eine Engine-Instanz (Standard: die erste).
	 */
	get( index = 0 ) {
		return engines[ index ] || null;
	},

	/**
	 * Navigiert zu einer Sektion (Index ab 0 oder Anchor-String).
	 */
	goTo( target, engineIndex = 0 ) {
		const engine = engines[ engineIndex ];
		return engine ? engine.goTo( target, { source: 'api' } ) : false;
	},

	next( engineIndex = 0 ) {
		const engine = engines[ engineIndex ];
		return engine ? engine.step( 1, 'api' ) : false;
	},

	previous( engineIndex = 0 ) {
		const engine = engines[ engineIndex ];
		return engine ? engine.step( -1, 'api' ) : false;
	},

	/**
	 * Führt den Callback aus, sobald die Engines initialisiert sind.
	 */
	ready( callback ) {
		if ( initialized ) {
			callback( api );
		} else {
			readyQueue.push( callback );
		}
	},
};

function boot() {
	// Im Elementor-Editor bleibt die Engine aus, damit Container
	// normal bearbeitet werden können.
	if ( isEditMode() ) {
		return;
	}

	document.querySelectorAll( '.sfps-horizontal' ).forEach( ( el ) => {
		if ( ! el.__sfpsSlider ) {
			const slider = new HorizontalSlider( el, globalConfig );

			if ( slider.slides && slider.slides.length > 1 ) {
				el.__sfpsSlider = slider;
			}
		}
	} );

	document.querySelectorAll( '.sfps-wrapper' ).forEach( ( el ) => {
		if ( ! el.__sfpsEngine ) {
			const engine = new FullpageEngine( el, globalConfig );

			if ( engine.sections && engine.sections.length > 1 ) {
				el.__sfpsEngine = engine;
				engines.push( engine );
			}
		}
	} );

	initialized = true;
	document.dispatchEvent( new CustomEvent( 'sfps:init', { detail: { engines } } ) );
	readyQueue.splice( 0 ).forEach( ( callback ) => callback( api ) );
}

window.SkapixFullpage = api;

if ( document.readyState === 'loading' ) {
	document.addEventListener( 'DOMContentLoaded', boot );
} else {
	boot();
}
